

export const useAudioContentStyles = () => {
    return {
        noiseSuppressionContainer: {
            marginTop: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#fff',
            cursor: 'pointer',
            padding: '2px 0',
            marginLeft: '18px',
            '& svg': {
                '--local-background': '#ffffff !important'
            }
        },
        noiseSuppressionLabel: {
            color: '#fff'
        }
    };
};

